import { Dialog } from "@mui/material";
import React, { useState } from "react";
import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg";
import { ReactComponent as EyeIcon } from "assets/img/svg/eye_open.svg";
import DetailsCard from "./DetailsCard";
import IconButtonWrapper from "../../../../../common/form-fields-mui/IconButtonWrapper";
export const titleStyles = {
  fontSize: "20px",
  fontWeight: 600,
  color: "#000",
  // minWidth: '600px'
};
const EPMRDetailsDialog = ({ epmrReceiptDetails }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="d-flex">
      - EPMR {epmrReceiptDetails?.epmrNumber}
      <div className="ml-2">
        {" "}
        <EyeIcon onClick={() => setOpen(true)} />
      </div>
      <Dialog onClose={() => setOpen(false)} open={open} maxWidth = "md">
        <div style={{ padding: "1.5rem", width: "53rem" }}>
          <div
            style={titleStyles}
            className="d-flex justify-content-between align-items-center"
          >
            <div className="text-bold text-dark">EPMR details</div>
            <IconButtonWrapper
              onClick={() => {
                setOpen(false);
              }}
            >
              <CrossIcon />
            </IconButtonWrapper>
          </div>
          <DetailsCard epmrReceiptDetails={epmrReceiptDetails} />
        </div>
      </Dialog>
    </div>
  );
};

export default EPMRDetailsDialog;
